import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { expensePeriodTypes, expenseStatuses } from "helpers/enums";
import { paths } from "helpers/paths";
import { NumericColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel, formatNumber, ymEvent } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { list as getDrivers } from "sources/books/drivers";
import { list as getTrailers } from "sources/books/trailers";
import { list as getTrucks } from "sources/books/trucks";
import { resourceEnum, resourceOptions } from "./constants";
import DisplayFiles from "./displayFIles";
import Form from "./form";

export class Expenses extends BookIndex {
    get resourceFilterValue() {
        const { params } = this.props;

        return params.customFilters.carId?.value
            ? resourceEnum.CAR
            : params.customFilters.driverId?.value
              ? resourceEnum.DRIVER
              : params.customFilters.trailerId?.value
                ? resourceEnum.TRAILER
                : "";
    }

    renderSelectResourceColumnFilter = (props) => {
        const handleResourceChange = ({ value }) => {
            if (value === resourceEnum.CAR) {
                props.onFilteredChange([
                    { id: "carId", filterType: "neNull", value: true },
                    { id: "driverId", filterType: "neNull", value: false },
                    { id: "trailerId", filterType: "neNull", value: false },
                ]);
            } else if (value === resourceEnum.DRIVER) {
                props.onFilteredChange([
                    { id: "carId", filterType: "neNull", value: false },
                    { id: "driverId", filterType: "neNull", value: true },
                    { id: "trailerId", filterType: "neNull", value: false },
                ]);
            } else if (value === resourceEnum.TRAILER) {
                props.onFilteredChange([
                    { id: "carId", filterType: "neNull", value: false },
                    { id: "driverId", filterType: "neNull", value: false },
                    { id: "trailerId", filterType: "neNull", value: true },
                ]);
            } else {
                props.onFilteredChange([
                    { id: "carId", filterType: "neNull", value: false },
                    { id: "driverId", filterType: "neNull", value: false },
                    { id: "trailerId", filterType: "neNull", value: false },
                ]);
            }
        };

        return (
            <SelectColumnFilter
                key={this.resourceFilterValue}
                {...props}
                filtered={{ resource: { value: this.resourceFilterValue } }}
                onFilteredChange={handleResourceChange}
                selectProps={{
                    inputProps: { name: "resource" },
                    options: resourceOptions,
                }}
            />
        );
    };

    renderSelectObjectColumnFilter = (props) => {
        const { params } = this.props;

        const resourcePayloads = {
            [resourceEnum.CAR]: {
                url: getTrucks,
                propName: "number",
                value: params.customFilters.carId?.value !== true ? params.customFilters.carId?.value : "",
                handleFilteredChange: ({ value }) => {
                    if (value) {
                        props.onFilteredChange({ id: "carId", filterType: "select", value });
                    } else {
                        props.onFilteredChange({ id: "carId", filterType: "neNull", value: true });
                    }
                },
            },
            [resourceEnum.DRIVER]: {
                url: getDrivers,
                propName: "user.fullName",
                filterPropName: "user/fullName",
                value: params.customFilters.driverId?.value !== true ? params.customFilters.driverId?.value : "",
                handleFilteredChange: ({ value }) => {
                    if (value) {
                        props.onFilteredChange({ id: "driverId", filterType: "select", value });
                    } else {
                        props.onFilteredChange({ id: "driverId", filterType: "neNull", value: true });
                    }
                },
            },
            [resourceEnum.TRAILER]: {
                url: getTrailers,
                propName: "number",
                value: params.customFilters.trailerId?.value !== true ? params.customFilters.trailerId?.value : "",
                handleFilteredChange: ({ value }) => {
                    if (value) {
                        props.onFilteredChange({ id: "trailerId", filterType: "select", value });
                    } else {
                        props.onFilteredChange({ id: "trailerId", filterType: "neNull", value: true });
                    }
                },
            },
        };

        const { url, propName, filterPropName, value, handleFilteredChange } = resourcePayloads[
            this.resourceFilterValue
        ] ?? {
            url: () => Promise.resolve(),
        };

        return (
            <SelectColumnFilter
                key={this.resourceFilterValue}
                {...props}
                filtered={{ object: { value } }}
                onFilteredChange={handleFilteredChange}
                selectProps={{
                    disabled: !this.resourceFilterValue,
                    inputProps: { name: "object" },
                    propName,
                    filterPropName,
                    url,
                }}
            />
        );
    };

    showFiles = (original) => {
        const { modal, source } = this.props;

        return modal({
            title: "Прикрепленные файлы",
            name: "default",
            windowMod: "sm",
            CustomBody: (props) => <DisplayFiles {...props} source={source} id={original.id} />,
        });
    };

    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "Ресурс",
                accessor: "resource",
                filterable: true,
                sortable: false,
                filterType: "select",
                Filter: (props) => {
                    return this.renderSelectResourceColumnFilter(props);
                },
                Cell: ({ row: { original } }) => {
                    return enumLabel(
                        resourceOptions,
                        original.carId
                            ? resourceEnum.CAR
                            : original.driverId
                              ? resourceEnum.DRIVER
                              : original.trailerId
                                ? resourceEnum.TRAILER
                                : "",
                    );
                },
                CSVExport: ({ original }) => {
                    return enumLabel(
                        resourceOptions,
                        original.carId
                            ? resourceEnum.CAR
                            : original.driverId
                              ? resourceEnum.DRIVER
                              : original.trailerId
                                ? resourceEnum.TRAILER
                                : "",
                    );
                },
            },
            {
                Header: "Объект",
                accessor: "object",
                filterable: true,
                sortable: false,
                filterType: "select",
                Filter: (props) => {
                    return this.renderSelectObjectColumnFilter(props);
                },
                Cell: ({ row: { original } }) => {
                    const path = original.carId
                        ? paths.trucksShow(original.carId)
                        : original.driverId
                          ? paths.driversShow(original.driverId)
                          : original.trailerId
                            ? paths.trackersShow(original.trailerId)
                            : "";
                    return (
                        <Link to={path} target="_blank">
                            {original.carNumber || original.driverName || original.trailerNumber}
                        </Link>
                    );
                },
                CSVExport: ({ original }) => {
                    return original.carNumber || original.driverName || original.trailerNumber;
                },
            },
            {
                Header: "Заявка",
                accessor: "bidId",
                filterable: true,
                sortable: true,
                filterType: "int",
                Cell: ({ value }) => {
                    return value && <Link to={paths.bidShow("bid", value)}>{value}</Link>;
                },
            },
            {
                Header: "Статья затрат",
                accessor: "typeId",
                filterable: true,
                sortable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "typeId" },
                            options: this.props.enums.expenseType || [],
                        }}
                    />
                ),
                Cell: ({ value }) => {
                    return enumLabel(this.props.enums.expenseType, value);
                },
            },
            {
                Header: "Сумма",
                accessor: "value",
                filterable: true,
                sortable: true,
                filterType: "numeric",
                Filter: NumericColumnFilter,
                Cell: ({ value }) => {
                    return formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                },
            },
            {
                Header: "Тип периодичности",
                accessor: "periodType",
                filterable: true,
                sortable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "periodType" },
                            options: expensePeriodTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => {
                    return enumLabel(expensePeriodTypes, value);
                },
                CSVExport: ({ value }) => {
                    return enumLabel(expensePeriodTypes, value);
                },
            },
            {
                Header: "Следующая дата списания",
                accessor: "nextDate",
                filterable: false,
                sortable: true,
                Cell: ({ value }) => {
                    return value ? dateTimeToView(value) : "";
                },
            },
            {
                Header: "Пробег для списания",
                accessor: "leftMileage",
                filterable: true,
                sortable: true,
                filterType: "numeric",
                Filter: NumericColumnFilter,
                Cell: ({ value }) => {
                    return formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                },
            },
            {
                Header: "Статус",
                accessor: "status",
                filterable: true,
                sortable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: expenseStatuses,
                        }}
                    />
                ),
                Cell: ({ value }) => {
                    return enumLabel(expenseStatuses, value);
                },
            },
            {
                Header: "Дата затраты",
                accessor: "date",
                filterable: false,
                sortable: true,
                Cell: ({ value }) => {
                    return value ? dateTimeToView(value) : "";
                },
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: false,
                sortable: true,
            },
            {
                Header: "",
                accessor: "actions",
                width: 180,
                filterable: false,
                sortable: false,
                notExportable: true,
                Cell: ({ row: { original } }) => {
                    return this.renderColumnActions(original);
                },
            },
        ];
    }

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };

    renderColumnActions = (original) => {
        const { history, modal, source, mergeParams } = this.props;

        const handleUpdate = () => {
            history.push(paths.expensesShow(original.id));
        };

        const handleDelete = () => {
            return modal({
                name: "confirm",
                title: "Удаление",
                text: "Вы действительно хотите удалить элемент?",
                onSuccessAction: () => {
                    mergeParams?.();
                },
                action: () => source.delItem({ id: original.id }),
            });
        };

        return (
            <>
                <div className="inline-btn inline-btn--without-icon mb-2" onClick={handleUpdate}>
                    Изменить
                </div>
                <div className="inline-btn inline-btn--without-icon" onClick={handleDelete}>
                    Удалить
                </div>
                {original.hasUploadedFile && (
                    <div className="link" onClick={() => this.showFiles(original)}>
                        <i className="icon-uEA0A-file show-bid__driver-chat-icon pr-1" />
                        Прикрепленные файлы
                    </div>
                )}
            </>
        );
    };

    renderCreateButton = () => {
        const { modal } = this.props;

        const action = () => {
            ymEvent("CreateAnExpense");
            return modal({
                name: "default",
                title: "Создание расхода",
                windowMod: "wide",
                CustomBody: Form,
            });
        };

        return (
            <div className="d-flex align-items-center">
                <a className="btn btn-brand btn-sm" onClick={action}>
                    Создать расход
                </a>
            </div>
        );
    };
}

export default tableContainer(Expenses, "expenses");
